<aside
  class="fixed top-0 left-0 z-40 w-64 h-screen pt-14 transition-transform -translate-x-full bg-white border-r border-gray-200 lg:translate-x-0 dark:bg-gray-800 dark:border-gray-700"
  aria-label="Sidenav" 
  id="drawer-navigation">
  
  <div class="overflow-y-auto py-5 px-3 h-full bg-white dark:bg-gray-800">
    <!-- Search bar móvil -->
    <!-- <form action="#" method="GET" class="md:hidden mb-2">
      <label for="sidebar-search" class="sr-only">Search</label>
      <div class="relative">
        <div class="flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none">
          <svg class="w-5 h-5 text-gray-500 dark:text-gray-400" fill="currentColor" viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z">
            </path>
          </svg>
        </div>
        <input type="text" name="search" id="sidebar-search"
          class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full pl-10 p-2 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
          placeholder="Search" />
      </div>
    </form> -->

    <!-- Menú principal -->
    <ul class="space-y-1">
      <li *ngFor="let item of menu">

        <!-- Link simple -->
        <a *ngIf="item.group === 'false'" 
          routerLink="{{item.url}}"
          [class.active-link]="isActiveRoute(item.url)"
          class="flex items-center p-3 text-base font-medium text-gray-700 rounded-lg transition-all duration-200 dark:text-gray-300 hover:bg-blue-50 dark:hover:bg-gray-700 hover:text-blue-600 dark:hover:text-white group">
          
          <mat-icon 
            class="icon-size-5 transition-colors duration-200" 
            [class.text-blue-600]="isActiveRoute(item.url)"
            [class.text-gray-500]="!isActiveRoute(item.url)"
            [class.dark:text-blue-400]="isActiveRoute(item.url)"
            [class.dark:text-gray-400]="!isActiveRoute(item.url)"
            matPrefix
            [svgIcon]="item.icon_name">
          </mat-icon>

          <span class="ml-3 flex-1">{{item.link_name}}</span>
        </a>

        <!-- Menú desplegable -->
        <div *ngIf="item.group === 'true'">
          <button 
            type="button"
            (click)="toggleMenu(item.menu_id)"
            [class.active-group]="isGroupActive(item)"
            [class.menu-open]="isMenuOpen(item.menu_id)"
            class="flex items-center p-3 w-full text-base font-medium text-gray-700 rounded-lg transition-all duration-200 group hover:bg-blue-50 dark:text-gray-300 dark:hover:bg-gray-700 hover:text-blue-600 dark:hover:text-white">
            
            <mat-icon 
              class="icon-size-5 transition-colors duration-200" 
              [class.text-blue-600]="isGroupActive(item) || isMenuOpen(item.menu_id)"
              [class.text-gray-500]="!isGroupActive(item) && !isMenuOpen(item.menu_id)"
              [class.dark:text-blue-400]="isGroupActive(item) || isMenuOpen(item.menu_id)"
              [class.dark:text-gray-400]="!isGroupActive(item) && !isMenuOpen(item.menu_id)"
              matPrefix
              [svgIcon]="item.icon_name">
            </mat-icon>
            
            <span class="flex-1 ml-3 text-left whitespace-nowrap">{{item.link_name}}</span>
            
            <svg 
              class="w-5 h-5 transition-transform duration-200"
              [class.rotate-180]="isMenuOpen(item.menu_id)"
              [class.text-blue-600]="isGroupActive(item) || isMenuOpen(item.menu_id)"
              [class.text-gray-500]="!isGroupActive(item) && !isMenuOpen(item.menu_id)"
              fill="currentColor" 
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd"
                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                clip-rule="evenodd">
              </path>
            </svg>
          </button>

          <!-- Submenú con animación -->
          <ul 
            class="submenu-transition overflow-hidden"
            [class.submenu-open]="isMenuOpen(item.menu_id)"
            [class.submenu-closed]="!isMenuOpen(item.menu_id)">
            <li *ngFor="let sub of item.submenu" class="mt-1">
              <a
                routerLink="{{sub.url}}"
                (click)="onSubmenuClick(item.menu_id)"
                [class.active-sublink]="isActiveRoute(sub.url)"
                class="flex items-center p-2.5 pl-11 w-full text-sm font-medium text-gray-600 rounded-lg transition-all duration-200 group hover:bg-blue-50 dark:text-gray-400 dark:hover:bg-gray-700 hover:text-blue-600 dark:hover:text-white relative">
                
                <!-- Indicador de submenú activo -->
                <span 
                  *ngIf="isActiveRoute(sub.url)"
                  class="absolute left-8 w-1.5 h-1.5 bg-blue-600 rounded-full dark:bg-blue-400">
                </span>
                
                {{sub.link_name}}
              </a>
            </li>
          </ul>
        </div>

      </li>
    </ul>

  </div>
</aside>